import { render, staticRenderFns } from "./ChargesGuardians.vue?vue&type=template&id=6a22a147"
import script from "./ChargesGuardians.vue?vue&type=script&lang=js"
export * from "./ChargesGuardians.vue?vue&type=script&lang=js"
import style0 from "./ChargesGuardians.vue?vue&type=style&index=0&id=6a22a147&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports